<div class="d-flex border-bottom"
  [ngClass]="{
    'email': details.correspondenceTypeId == 1,
    'letter': details.correspondenceTypeId == 2,
    'casefile': details.correspondenceTypeId == 3 || details.correspondenceTypeId == 7,
    'phonecall': details.correspondenceTypeId == 4,
    'textmessage': details.correspondenceTypeId == 5,
    'fax': details.correspondenceTypeId == 6,
    'note': details.correspondenceTypeId == 8,
    'keydate': details.correspondenceTypeId == 9,
    'onhold': details.correspondenceTypeId == 10,
    'offhold': details.correspondenceTypeId == 11,
    'highlighted': details.highlighted
  }">

  <!-- Checkbox -->
  <div *ngIf="selectable" class="d-flex align-items-center px-2" style="width: 30px;">
    <input type="checkbox" class="form-check-input" [(ngModel)]="selected">
  </div>

  <!-- Main content -->
  <div class="flex-grow-1">

    <!-- Body row -->
    <div class="d-flex align-items-center p-2">

      <!-- Icon -->
      <div class="me-3 d-flex justify-content-center align-items-center" style="width: 40px; min-width: 40px;">
        <fa-layers [fixedWidth]="true">
          <fa-icon *ngIf="details.correspondenceTypeId == 1" [icon]="faEnvelopeOpen" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 1 && details.emailItem.attachments.length > 0" [icon]="faPaperclip" transform="right-20 down-2"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 1 && details.emailItem.isHighImportance" [icon]="faExclamation" transform="left-18" class="high-importance" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 2" [icon]="faEnvelopeOpenText" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 3 || details.correspondenceTypeId == 7" [icon]="getFileTypeIcon(details.caseFile?.format)" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 4" [icon]="faPhone" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 5" [icon]="faSms" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 6" [icon]="faFax" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 8" [icon]="faStickyNote" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 9" [icon]="faCalendarDay" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 10" [icon]="faPause" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceTypeId == 11" [icon]="faPlay" size="lg"></fa-icon>
          <fa-icon *ngIf="details.correspondenceDirectionId == 1" class="outbound" [icon]="faArrowAltLeft" transform="left-12 down-4"></fa-icon>
          <fa-icon *ngIf="details.correspondenceDirectionId == 2" class="inbound" [icon]="faArrowAltRight" transform="left-12 up-4"></fa-icon>
        </fa-layers>
      </div>

      <!-- Description -->
      <div class="flex-grow-1">
        <div class="fw-bold">{{details.summary}}</div>
        <div class="small text-muted">{{details.source}}</div>
      </div>

    </div>

    <!-- Email attachments -->
    <div *ngIf="details.correspondenceTypeId == 1">
      <div *ngFor="let attachment of details.emailItem.attachments" class="d-flex align-items-center ps-4 py-1 small attachment">
        <div class="angle"></div>
        <fa-icon [icon]="faPaperclip" class="mx-2 ms-4"></fa-icon>
        <span>{{attachment.caseFile.fileName}}</span>
      </div>
    </div>

    <!-- Case file email attachments -->
    <div *ngIf="details.correspondenceTypeId == 3 && details.caseFile.format == 3">
      <div *ngFor="let attachment of details.caseFile.emailAttachments" class="d-flex align-items-center ps-4 py-1 small attachment"
           (click)="openAttachment(attachment.caseFileEmailAttachmentId)">
        <div class="angle"></div>
        <fa-icon [icon]="faPaperclip" class="mx-2 ms-4"></fa-icon>
        <span>{{attachment.fileName}} ({{attachment.fileSize / 1024 | number: '1.2-2'}}KB)</span>
      </div>
    </div>

    <!-- Fax attachments -->
    <div *ngIf="details.correspondenceTypeId == 6">
      <div *ngFor="let attachment of details.faxItem.attachments" class="d-flex align-items-center ps-4 py-1 small attachment">
        <div class="angle"></div>
        <fa-icon [icon]="faPaperclip" class="mx-2 ms-4"></fa-icon>
        <span>{{attachment.caseFile.fileName}}</span>
      </div>
    </div>

  </div>

  <!-- Right column: initials + date -->
  <div class="d-flex align-items-center justify-content-end gap-2 p-2" style="width: 160px; min-width: 160px;">
  
      <div *ngIf="details.addedByUser"
          class="rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"
          [ngStyle]="{'background-color': getColourForUser(details.addedByUser)}"
          style="width: 32px; height: 32px; color: white; text-shadow: 0 0 2px black; font-size: 0.75rem;">
        {{details.addedByUser.firstName.charAt(0)}}{{details.addedByUser.lastName.charAt(0)}}
      </div>
      <div *ngIf="!details.addedByUser"
          class="rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"
          style="width: 32px; height: 32px; background-color: #7fc2ff; color: white; text-shadow: 0 0 2px black; font-size: 0.75rem;">
        SYS
      </div>

      <div class="text-muted" style="font-size: 0.9rem;">
        {{details.dateCreated | date:'dd/MM/yyyy'}}<br>
        {{details.dateCreated | date:'HH:mm:ss'}}
      </div>

  </div>

</div>